<div class="ra-category-root">
  <button
    pButton
    class="p-button-primary !px-4 !py-2 w-full sm:w-full flex justify-center"
    (click)="handleStatusOpened($event)"
  >
    <div class="w-[24px] h-[24px]">
      @if (isOpened) {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.75 5.25L5.25 18.75" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M18.75 18.75L5.25 5.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      } @else {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.75 6H20.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.75 12H10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.75 18H12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.25 16.5C18.9069 16.5 20.25 15.1569 20.25 13.5C20.25 11.8431 18.9069 10.5 17.25 10.5C15.5931 10.5 14.25 11.8431 14.25 13.5C14.25 15.1569 15.5931 16.5 17.25 16.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19.3721 15.6216L21.7505 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }
    </div>

    <span class="ml-2">Категории</span>
  </button>

  <div
    *ngIf="isOpened"
    class="absolute top-full left-1/2 -translate-x-1/2 w-screen p-[32px_0px_52px_16px] bg-[rgba(255,255,255,1)] z-[101] hidden min-[1100px]:flex"
    (click)="$event.stopPropagation()"
    #menuElement
  >
    <div class="max-w-[1400px] mx-auto w-full flex">
      <div class="flex flex-col min-w-[280px] max-w-[280px]">
        <div
          class="w-full h-[52px] rounded-xl px-4 py-[10px] flex items-center cursor-default"
          [ngClass]="{ 'bg-[rgba(253,239,255,1)]': currentIndex === index }"
          (mouseover)="selectTab(index)"
          *ngFor="let item of menu; let index = index"
        >
          <!--        <div *clientSideRendering [inlineSVG]="item.svg"></div>-->
          <div class="ml-2 text-base">{{ item.type }}</div>
        </div>
      </div>

      <div class="h-full w-[1px] bg-[rgba(241,241,244,1)] ml-4 mr-12"></div>

      <div class="overflow-y-auto overflow-x-hidden custom-scroll w-full">
        <div class="text-3xl leading-[38.4px] font-bold">
          {{ menu[currentIndex].type }}
        </div>

        <ra-category-menu
          [currentIndex]="currentIndex"
          [dataCategory]="dataCategory"
          [isOpened]="isOpened"
          [mapStatusOpenedMenu]="mapStatusOpenedMenu"
          [amountCol]="amountCol"
          (handleOpened)="handleOpened()"
        ></ra-category-menu>
      </div>
    </div>
  </div>

  <div
    (click)="$event.stopPropagation()"
    class="min-[1100px]:hidden flex flex-col absolute top-0 left-0 right-0 bottom-0 w-screen h-screen bg-[rgba(255,255,255,1)] z-[20]"
    *ngIf="isOpened"
  >
    <div
      class="h-12 flex justify-center items-center border-b-[1px] border-solid border-[rgba(241,241,244,1)] relative"
    >
      <div class="font-bold text-lg text-center">
        {{ !isOpenedMobileMenu ? 'Категории' : menu[currentIndex].type }}
      </div>
      <div class="absolute left-[21px] top-1/2 -translate-y-1/2">
        <div
          class="cursor-pointer"
          (click)="handleOpened(); handleClassBody()"
          *ngIf="!isOpenedMobileMenu; else back"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.75 5.25L5.25 18.75"
              stroke="#050A24"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.75 18.75L5.25 5.25"
              stroke="#050A24"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <ng-template #back>
          <div class="cursor-pointer" (click)="isOpenedMobileMenu = false">
            <svg
              width="10"
              height="18"
              viewBox="0 0 10 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 16.5L1.5 9L9 1.5"
                stroke="#050A24"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </ng-template>
      </div>
    </div>

    <div
      class="flex flex-col mt-4"
      *ngIf="!isOpenedMobileMenu; else selectSubMenu"
    >
      <div
        class="w-full h-[52px] rounded-xl px-4 py-[10px] flex items-center"
        (click)="selectTab(index, true)"
        *ngFor="let item of menu; let index = index"
      >
<!--        <div *clientSideRendering [inlineSVG]="item.svg"></div>-->
        <div class="ml-2 text-base flex-1">{{ item.type }}</div>
      </div>
    </div>

    <ng-template #selectSubMenu>
      <div
        class="overflow-y-auto overflow-x-hidden h-[calc(100dvh-48px)] px-4 mt-8 pb-4"
      >
        <div class="text-3xl leading-[38.4px] font-bold">
          {{ menu[currentIndex].type }}
        </div>

        <ra-category-menu
          [currentIndex]="currentIndex"
          [dataCategory]="dataCategory"
          [isOpened]="isOpened"
          [mapStatusOpenedMenu]="mapStatusOpenedMenu"
          [amountCol]="amountCol"
          (handleOpened)="handleOpened()"
        ></ra-category-menu>
      </div>
    </ng-template>
  </div>
</div>
